import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';

export default (deviceType: string) => {
  return useApiQuery<{ devices: { deviceId: string; type: string }[] }>({
    queryKey: [QueryKeys.parentControllers, deviceType],
    apiPath: `/devices/parent-controllers?deviceType=${deviceType}`,
    method: 'GET',
    useV2API: true,
    enabled: !!deviceType,
  });
};
